import { Table } from "@/features/Table";
import { type Version, versions_columns } from "./columns";
import { type FilterVersionsSchema, FilterVersions } from "./filter";
import { useLocation } from "react-router-dom";

const client = "instit-quantilia";
const table_name = "versions";

export const VersionsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<Version, FilterVersionsSchema>
      label="Versions"
      client={client}
      table_name={table_name}
      columns={versions_columns}
      filter={<FilterVersions />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
